import {
  DOWNLOAD_INVOICE,
  DOWNLOAD_INVOICE_IS_ERROR,
  DOWNLOAD_INVOICE_IS_PENDING,
  FETCH_INVOICE,
  FETCH_INVOICE_BY_ID,
  FETCH_INVOICE_BY_ID_IS_ERROR,
  FETCH_INVOICE_BY_ID_IS_PENDING,
  FETCH_INVOICE_IS_ERROR,
  FETCH_INVOICE_IS_PENDING,
  FETCH_INVOICE_UNPAID,
  FETCH_INVOICE_UNPAID_IS_ERROR,
  FETCH_INVOICE_UNPAID_IS_PENDING,
  RESET_INVOICE_STATE,
  SORT,
} from 'services/Account/Invoice/types';
import { SortDirection } from 'types/common/sorting';
import { sort } from 'utils/functions';

const invoiceReducer = (
  state = {
    invoices: [],
    invoice: {},
    sortBy: 'creationDate',
    sortDirection: 'DESC' as SortDirection,
    params: {
      type: 'function',
      sortSearchParam: 'creationDate',
      sortSearchValue: (item: $TSFixMe) => item.creationDate,
    },
    fetchInvoicesIsCompleted: false,
    fetchInvoicesIsPending: false,
    fetchInvoicesIsError: null,
    fetchUnpaidInvoicesIsCompleted: false,
    fetchUnpaidInvoicesIsPending: false,
    fetchUnpaidInvoicesIsError: null,
    fetchInvoiceByIdIsCompleted: false,
    fetchInvoiceByIdIsPending: false,
    fetchInvoiceByIdIsError: null,
    downloadIsCompleted: false,
    downloadIsPending: false,
    downloadIsError: null,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        invoices: sort(state.invoices, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case FETCH_INVOICE: {
      // Transform data: invoiceNumber → id, id → idLegacy
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const transformedInvoices = action.data.map((invoice: $TSFixMe) => ({
        ...invoice,
        id: invoice.invoiceNumber,
        idLegacy: invoice.id,
      }));

      return {
        ...state,

        invoices: sort(transformedInvoices, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params.sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchInvoicesIsCompleted: true,
        fetchInvoicesIsPending: false,
        fetchInvoicesIsError: null,
      };
    }

    case FETCH_INVOICE_IS_PENDING:
      return {
        ...state,
        fetchInvoicesIsCompleted: false,
        fetchInvoicesIsPending: true,
        fetchInvoicesIsError: null,
      };
    case FETCH_INVOICE_IS_ERROR:
      return {
        ...state,
        fetchInvoicesIsCompleted: true,
        fetchInvoicesIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInvoicesIsError: action.error,
      };

    case FETCH_INVOICE_UNPAID:
      return {
        ...state,
        fetchUnpaidInvoicesIsCompleted: true,
        fetchUnpaidInvoicesIsPending: false,
        fetchUnpaidInvoicesIsError: null,
      };
    case FETCH_INVOICE_UNPAID_IS_PENDING:
      return {
        ...state,
        fetchUnpaidInvoicesIsCompleted: false,
        fetchUnpaidInvoicesIsPending: true,
        fetchUnpaidInvoicesIsError: null,
      };
    case FETCH_INVOICE_UNPAID_IS_ERROR:
      return {
        ...state,
        fetchUnpaidInvoicesIsCompleted: true,
        fetchUnpaidInvoicesIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchUnpaidInvoicesIsError: action.error,
      };

    case FETCH_INVOICE_BY_ID: {
      // Transform data: invoiceNumber → id, id → idLegacy
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const originalInvoice = action.data[0];

      const transformedInvoice = {
        ...originalInvoice,
        id: originalInvoice.invoiceNumber,
        idLegacy: originalInvoice.id,
      };

      return {
        ...state,
        invoice: transformedInvoice,
        fetchInvoiceByIdIsCompleted: true,
        fetchInvoiceByIdIsPending: false,
        fetchInvoiceByIdIsError: null,
      };
    }

    case FETCH_INVOICE_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchInvoiceByIdIsCompleted: false,
        fetchInvoiceByIdIsPending: true,
        fetchInvoiceByIdIsError: null,
      };
    case FETCH_INVOICE_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchInvoiceByIdIsCompleted: true,
        fetchInvoiceByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInvoiceByIdIsError: action.error,
      };
    case DOWNLOAD_INVOICE:
      return {
        ...state,
        downloadIsCompleted: true,
        downloadIsPending: false,
        downloadIsError: null,
      };
    case DOWNLOAD_INVOICE_IS_PENDING:
      return {
        ...state,
        downloadIsCompleted: false,
        downloadIsPending: true,
        downloadIsError: null,
      };
    case DOWNLOAD_INVOICE_IS_ERROR:
      return {
        ...state,

        downloadIsCompleted: false,
        downloadIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        downloadIsError: action.error,
      };

    case RESET_INVOICE_STATE:
      return {
        ...state,
        invoices: [],
        fetchInvoicesIsCompleted: false,
        fetchInvoicesIsPending: false,
        fetchInvoicesIsError: null,
        invoice: {},
        fetchInvoiceByIdIsCompleted: false,
        fetchInvoiceByIdIsPending: false,
        fetchInvoiceByIdIsError: null,
        downloadIsCompleted: false,
        downloadIsPending: false,
        downloadIsError: null,
      };

    default:
      return state;
  }
};

export default invoiceReducer;
